import {
  Component,
  ElementRef,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  inject,
} from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { PaymentService } from '../../services/payment/payment.service';

@Component({
  selector: 'app-pago-libre',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    CardModule,
    DividerModule,
    InputTextModule,
    InputNumberModule,
  ],
  templateUrl: './pago-libre.component.html',
  styleUrl: './pago-libre.component.scss',
})
export class PagoLibreComponent implements OnInit {
  @ViewChild('redsysForm') redsysForm!: ElementRef<HTMLFormElement>;

  private platformId = inject(PLATFORM_ID);
  private route = inject(ActivatedRoute);
  private fb = inject(FormBuilder);
  private paymentService = inject(PaymentService);

  form!: FormGroup;

  loading = false;
  loadingBizum = false;
  errorMsg = '';
  formSubmitted = false;

  // Redsys form fields
  Ds_SignatureVersion = '';
  Ds_MerchantParameters = '';
  Ds_Signature = '';
  tpvUrl = '';

  activateBizum = false; // Habilitar botón Bizum (si el TPV lo permite)

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const concept = params.get('concept') ?? '';
    const amount = parseFloat(params.get('amount') ?? '0') || null;

    this.form = this.fb.group({
      concept: [concept, [Validators.required, Validators.maxLength(200)]],
      amount: [amount, [Validators.required, Validators.min(0.01)]],
      name: ['', [Validators.required]],
      // Email obligatorio: permite relacionar el pago con la ficha del
      // cliente. El teléfono es opcional.
      email: ['', [Validators.required, Validators.email]],
      phone: [''],
    });
  }

  get amountValue(): number {
    return this.form?.get('amount')?.value ?? 0;
  }

  get amountFormatted(): string {
    return `${this.amountValue.toFixed(2)} €`;
  }

  async pay(isBizum = false): Promise<void> {
    this.formSubmitted = true;
    if (this.form.invalid) return;

    isBizum ? (this.loadingBizum = true) : (this.loading = true);
    this.errorMsg = '';

    try {
      const v = this.form.value;
      const formData = await this.paymentService.createLibrePayment({
        amount: v.amount,
        concept: v.concept,
        isBizum,
        customer: { name: v.name, email: v.email, phone: v.phone },
      });

      this.Ds_SignatureVersion = formData.Ds_SignatureVersion;
      this.Ds_MerchantParameters = formData.Ds_MerchantParameters;
      this.Ds_Signature = formData.Ds_Signature;
      this.tpvUrl = formData.tpvUrl;

      // Submit nativo SSR-safe
      if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => this.redsysForm.nativeElement.submit(), 50);
      }
    } catch (err: any) {
      this.errorMsg =
        err?.message ?? 'Error al procesar el pago. Inténtalo de nuevo.';
    } finally {
      this.loading = false;
      this.loadingBizum = false;
    }
  }
}
